import { render, staticRenderFns } from "./DeviceShareSyncDialog.vue?vue&type=template&id=1375fc70&scoped=true"
import script from "./DeviceShareSyncDialog.vue?vue&type=script&lang=ts"
export * from "./DeviceShareSyncDialog.vue?vue&type=script&lang=ts"
import style0 from "./DeviceShareSyncDialog.vue?vue&type=style&index=0&id=1375fc70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1375fc70",
  null
  
)

export default component.exports